import { useEffect, useState } from "react";
import { mostraAlertaError, mostraAlertaOk } from "../../../componentes/alerts/sweetAlert";
import { AxiosPrivado } from "../../../componentes/axios/Axios";
import { ErroresPeticion } from "../../../componentes/axios/ErroresPeticion";
import Card from "../../../componentes/contenedores/Card";
import { IdentificarEstacion } from '../../../componentes/estacion/Estacion';
import Page from "../../../componentes/plantilla/Page";
import { AperturaGuardar, CajaVerificar, DenominacionListar, AperturaListar } from "../../../configuracion/apiUrls";
import { useContextUsuario } from "../../../contexto/usuario/UsuarioContext";
import { ImprimirApertura } from "./imprimir/ImprimirApertura";
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";
import { useNavigate } from "react-router-dom";

const HomeApertura = () => {
  const { usuario } = useContextUsuario();
  const { ActualizarLista, setListaApertura } = useContextEmpleado();
  const [denominaciones, setDenominaciones] = useState([]);
  const [cantidades, setCantidades] = useState({});
  const [efectivoTotal, setEfectivoTotal] = useState("");
  const [cajaId, setCajaId] = useState(null);
  const navigate = useNavigate();

  const verificarYCargarCaja = async () => {
    try {
      const estacionDatos = await IdentificarEstacion();
      const response = await AxiosPrivado.post(CajaVerificar, { estacionDatos });
      if (response.data.estado === "AB") {
        mostraAlertaError("La caja ya está abierta. No se puede registrar una nueva apertura.");
        navigate("/app/admin/cajeros/cierre");
      }
      const caja = response.data;
      setCajaId(caja.id);
      //mostraAlertaOk("Caja autenticada correctamente");
    } catch (error) {
      ErroresPeticion(error);
      //console.error("Autenticación de caja fallida:", error);
    }
  };

  useEffect(() => {
    verificarYCargarCaja();

    const fetchDenominaciones = async () => {
      try {
        const response = await AxiosPrivado.get(DenominacionListar);
        const datos = response.data;

        const cantidadesIniciales = {};
        datos.forEach((denom) => {
          cantidadesIniciales[denom.id] = "";
        });

        setDenominaciones(datos);
        setCantidades(cantidadesIniciales);
      } catch (error) {
        console.error("Error cargando las denominaciones:", error);
      }
    };

    fetchDenominaciones();
  }, []);

  const handleChange = (id, cantidad) => {
    const cantidadLimpia = cantidad === "" ? "" : Math.max(0, parseInt(cantidad, 10));
    setCantidades((prev) => ({
      ...prev,
      [id]: cantidadLimpia,
    }));
  };

  const calcularTotalDenominacion = (id) => {
    const denominacion = denominaciones.find((d) => d.id === id);
    return (parseInt(cantidades[id]) || 0) * (denominacion?.valor || 0);
  };

  const totalIngresado = denominaciones.reduce(
    (sum, denom) => sum + calcularTotalDenominacion(denom.id),
    0
  );

  const diferencia = (parseFloat(efectivoTotal) || 0) - totalIngresado;

  const datos = {
    titulo: {
      titulo: "Apertura de caja",
      url: "/app/admin/cajeros/apertura",
      tituloUrl: "Menú Apertura",
      nombreUrl: "Inicio",
    },
  };

  const guardarApertura = async () => {
    if (!cajaId) {
      mostraAlertaError("No se puede guardar. La caja ya está abierta.");
      return;
    }

    try {
      const detalleApertura = Object.keys(cantidades)
        .filter((id) => parseInt(cantidades[id]) > 0)
        .map((id) => ({
          cantidad: parseInt(cantidades[id]),
          denominacionId: parseInt(id),
        }));

      const datos = {
        efectivo: parseFloat(efectivoTotal),
        cajaId,
        cierre: false,
        anulado: false,
        detalleApertura,
        usuarioId: usuario.id,
      };

      const response = await AxiosPrivado.post(AperturaGuardar, datos);
      mostraAlertaOk("Apertura guardada correctamente");
      ImprimirApertura(response.data, usuario);
      ActualizarLista(AperturaListar, setListaApertura);
      setCantidades({});
      setEfectivoTotal(0);
      //console.log(response.data);
    } catch (error) {
      mostraAlertaError(
        error.response?.data?.mensaje || "Error al guardar la apertura."
      );
      console.error("Error al guardar apertura:", error);
    }
  };

  return (
    <Page datos={datos}>
      <Card>
        <div className="mb-3">
          <div className="row g-2 align-items-center">
            <div className="col-12 col-md-auto">
              <label className="form-label mb-0"><strong>Efectivo de apertura:</strong></label>
            </div>

            <div className="col-12 col-sm-6 col-md-4">
              <input
                type="number"
                className="form-control"
                value={efectivoTotal}
                onChange={(e) => setEfectivoTotal(e.target.value)}
                placeholder="Ingrese el total"
              />
            </div>

            <div className="col-12 col-sm-6 col-md-auto">
              <button
                className="btn btn-success w-100 my-2"
                onClick={guardarApertura}
                disabled={efectivoTotal === "" || isNaN(efectivoTotal) || diferencia !== 0}
              >
                Guardar Apertura
              </button>
            </div>
          </div>
        </div>
        {/* Mensaje de diferencia */}
        <div className={`alert ${diferencia === 0 ? "alert-success" : "alert-warning"}`}>
          {diferencia === 0
            ? "✅ El total ingresado coincide con el efectivo total."
            : `⚠️ Diferencia: L ${diferencia.toFixed(2)}`}
        </div>
        <div className="table-responsive">
          <table className="table table-bordered table-striped table-hover shadow-sm">
            <thead className="bg-dark text-white">
              <tr>
                <th>Denominación</th>
                <th>Tipo</th>
                <th>Valor</th>
                <th>Cantidad</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {denominaciones.map((denom) => (
                <tr key={denom.id}>
                  <td>{denom.nombre}</td>
                  <td>{denom.tipo === "BI" ? "Billete" : "Moneda"}</td>
                  <td>L {denom.valor.toFixed(2)}</td>
                  <td>
                    <input
                      type="number"
                      min="0"
                      value={cantidades[denom.id] ?? ""}
                      onChange={(e) => handleChange(denom.id, e.target.value)}
                      className="form-control"
                      style={{ width: "80px" }}
                    />
                  </td>
                  <td>L {calcularTotalDenominacion(denom.id).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="4" className="text-right font-weight-bold">
                  Total General:
                </td>
                <td className="font-weight-bold">L {totalIngresado.toFixed(2)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </Card>
    </Page>
  );
};

export default HomeApertura;
